import { call, put, takeLatest } from "redux-saga/effects";
import { saveGlossaryEntry as saveGlossaryEntryApi } from "../../../services/coilConfiguratorApi";
import type { GlossaryEntry } from "../../../glossary";
import { saveGlossaryEntrySuccess, showToast } from "../actions";
import {
  SAVE_GLOSSARY_ENTRY,
  SAVE_GLOSSARY_ENTRY_FAILURE,
} from "../types";

function* saveGlossaryEntrySaga(
  action: ReturnType<typeof import("../actions").saveGlossaryEntry>,
): Generator {
  try {
    const saved = (yield call(
      saveGlossaryEntryApi,
      action.entryKey,
      action.entry,
    )) as GlossaryEntry;
    yield put(saveGlossaryEntrySuccess(action.entryKey, saved));
    yield put(showToast("Glossary entry saved."));
  } catch (error) {
    const message = error instanceof Error ? error.message : "Failed to save glossary entry";
    yield put({ type: SAVE_GLOSSARY_ENTRY_FAILURE, error: message, entryKey: action.entryKey });
    yield put(showToast(message, "error"));
  }
}

function* glossaryWatcher(): Generator {
  yield takeLatest(SAVE_GLOSSARY_ENTRY, saveGlossaryEntrySaga);
}

export default glossaryWatcher;
